// @ts-nocheck
import React from 'react';
import { Row, Button, Dropdown, Menu, Input, DatePicker } from "antd";
import styled from "styled-components";
import Search_icon from '../../../assets/search-icon.svg'
import dropdown_Arrow from '../../../assets/dropdown-arrow.svg'
import "../../css/custom-report-filter.css"
import moment from 'moment-timezone';
const CustomReportFilter = props => {

    const {
        filterData,
        defaultFilter,
        onfilterChange,
        verticalList,
        me
    } = props;
    const { RangePicker } = DatePicker;
    const [selectedFilter, setFilter] = React.useState('Name')
    const [selectedVertical, setSelectedVertical] = React.useState({ type: "Select Vertical" })
    const [filterList, setfilterList] = React.useState([])
    const [filterValue, setfilterValue] = React.useState()
    React.useEffect(() => {
        if (filterData) {
            setfilterList(filterData)
        }
    }, [filterData])
    React.useEffect(() => {
        if (defaultFilter) {
            setFilter(defaultFilter?.key)
        }
    }, [defaultFilter])
    const filterValueChange = (value) => {
        setfilterValue(value)
        switch (selectedFilter) {
            case "Name": {
                onfilterChange({ nameIcontains: value })
                break
            }
            case "Email": {
                onfilterChange({ emailIcontains: value })
                break
            }
            case "Vertical": {
                onfilterChange({ verticalNameIcontains: { name: value?.type, organization: me?.employee?.organizationSet?.edges[0]?.node?.id } })
                break
            }
            case "Date": {
                onfilterChange({ responseDate_Range: value })
                break
            }
            default: break
        }
    }

    const verticalMenu = () => (
        <Menu style={{ maxHeight: '200px', overflow: 'auto' }} >
            {
                verticalList && (
                    verticalList?.map((data) =>
                        <Menu.Item key={data?.key} onClick={() => { setSelectedVertical(data); filterValueChange(data) }}>
                            {data?.type}
                        </Menu.Item>
                    )
                )
            }
        </Menu>
    );

    const FilterType = (
        <div className='poc-report-custom-filter'>
            {(selectedFilter === 'Name' || selectedFilter === 'Email') && (
                <div style={{ position: 'relative' }}>
                    <Input
                        placeholder=""
                        className='filter-input'
                        value={filterValue}
                        style={{ paddingLeft: "30px", borderRadius: "12px 0px 0px 12px" }}
                        onChange={e => (filterValueChange(e.target.value))}
                        autoComplete='off'
                    />
                    <img style={{ position: "absolute", left: "7px", top: "10px", width: "20px" }} src={Search_icon} alt="" />
                </div>
            )}
            {selectedFilter === 'Vertical' && (
                <div style={{ position: 'relative', display: 'flex' }}>
                    <Dropdown overlay={verticalMenu} overlayStyle={{ zIndex: "1050" }} style={{ border: '1px solid #D9D9D9', color: '#BBBBBB' }} trigger="click" className="filter-drop">
                        <DropdownButton style={{ justifyContent: "center", borderRadius: "12px 0px 0px 12px", minWidth: "250px", maxWidth: "300px", display: "flex", flexFlow: 1 }}>
                            <p className='selected-filter' style={{ marginTop: '13px', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left', paddingTop: "2px" }}>{selectedVertical?.type}</p>
                            <img src={dropdown_Arrow} alt="" style={{ width: "13px", height: "10px" }} />
                        </DropdownButton>
                    </Dropdown>
                </div>
            )}
            {selectedFilter === 'Date' && (
                <RangePicker
                    className='filter-input report-date-picker'
                    defaultValue={null}
                    format={'DD/MM/YY'}
                    style={{ borderRadius: "12px 0px 0px 12px" }}
                    onChange={(e) => { filterValueChange(e) }}
                    allowClear={true}
                    disabledDate={current => {
                        return current.isAfter(moment())
                    }}
                />
            )}
        </div>
    )

    const Filtermenu = () => (
        <Menu style={{ maxHeight: '200px', overflow: 'auto' }} >
            {
                filterList && (
                    filterList?.map((data) =>
                        <Menu.Item key={data?.key} onClick={() => { setfilterValue(null); setFilter(data?.key) }}>
                            {data?.type}
                        </Menu.Item>
                    )
                )
            }
        </Menu>
    );

    return (
        <>
            <Row style={{ flexFlow: "unset" }}>
                <div>
                    {FilterType}
                </div>
                <Dropdown overlay={Filtermenu} overlayStyle={{ zIndex: "1050" }} style={{ border: '1px solid #D9D9D9', color: '#BBBBBB' }} trigger="click" className="filter-drop">
                    <DropdownButton style={{ justifyContent: "center", borderRadius: "0px 12px 12px 0px" }}>
                        <p className='selected-filter' style={{ marginTop: '13px', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left', paddingTop: "2px" }}>{selectedFilter}</p>
                        <img src={dropdown_Arrow} alt="" style={{ width: "13px", height: "10px" }} />
                    </DropdownButton>
                </Dropdown>
            </Row>
        </>
    )

}

export default CustomReportFilter;

const DropdownButton = styled(Button)`
width:140px !important;
display:flex;
height:36px;
justify-content:space-between;
align-items:center;
gap:5px
`